module.exports = __webpack_public_path__ + "static/BgPage-eb671667e2ea6af7a3d7913ec22a1bec.png";